import { useFormContext } from 'react-hook-form';
import { FormContainer } from 'components/layout';
import { Box } from '@mui/material';
import { useLocationParams, useSyncGlobalApp } from 'hooks';
import { AdAccountSelect } from './TikTokFormComponents';
import { memo, useCallback, useEffect } from 'react';
import { getDefaultTikTokPack } from '../utils/buildPacksFromCreativesByPack';

const AppAccount = memo(() => {
  const { setValue, watch } = useFormContext();
  const accountId = (watch('accountId') as string | undefined) ?? '';
  const {
    setAdAccount: setAdAccountParam,
    setCreativesByPack: setCreativesByPackParam,
    setSelectedCampaigns: setSelectedCampaignsParam,
    setSelectedAdSets: setSelectedAdSetsParam,
    setFilterCampaignsByName: setFilterCampaignsByNameParam,
    setFilterAdSetsByName: setFilterAdSetsByNameParam,
  } = useLocationParams();

  const clearDownstreamSelections = useCallback(() => {
    setValue('selectedCampaigns', []);
    setValue('selectedAdGroups', []);
    setValue('selectedCreatives', []);
    setValue('packsWithCreatives', [getDefaultTikTokPack()], { shouldValidate: true });
    setSelectedCampaignsParam([]);
    setSelectedAdSetsParam([]);
    setCreativesByPackParam([]);
    setFilterCampaignsByNameParam([]);
    setFilterAdSetsByNameParam([]);
  }, [
    setCreativesByPackParam,
    setFilterAdSetsByNameParam,
    setFilterCampaignsByNameParam,
    setSelectedAdSetsParam,
    setSelectedCampaignsParam,
    setValue,
  ]);

  const handleChangeApp = useCallback(() => {
    setValue('accountId', '', { shouldValidate: true });
    setAdAccountParam(undefined);
    clearDownstreamSelections();
  }, [clearDownstreamSelections, setAdAccountParam, setValue]);

  const handleChangeAccId = useCallback(() => {
    clearDownstreamSelections();
  }, [clearDownstreamSelections]);

  useSyncGlobalApp(handleChangeApp);

  useEffect(() => {
    setAdAccountParam(accountId || undefined);
  }, [accountId, setAdAccountParam]);

  return (
    <FormContainer title={'Choose Ad Account'}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, justifyContent: 'start', width: '100%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, width: '100%' }}>
          <Box sx={{ display: 'flex', flex: 1 }}>
            <AdAccountSelect handleChange={handleChangeAccId} />
          </Box>
          <Box sx={{ display: 'flex', flex: 1 }}></Box>
        </Box>
      </Box>
    </FormContainer>
  );
});

AppAccount.displayName = 'AppAccount';

export default AppAccount;
